import { useContext, useEffect } from "react"
import { useParams } from "react-router"
import axios from "axios"
import "./articlelayout.css"
import emailContext from "./emailcontext"
import articleContext from "./articlecontext"
export default function Article() {
    const id = useParams()
    const [artdata, setArtdata] = useContext(articleContext)
    const [email, setEmail] = useContext(emailContext)
    useEffect(() => {
        if (!artdata || artdata.length === 0) {
            axios.get('https://dojma-website-2pip.onrender.com/data')
                .then(res => setArtdata(res.data.slice().reverse()))
                .catch(err => console.error(err))
        }
    }, [])
    if (!artdata || artdata.length === 0) { return <div>Loading...</div> }
    else {
        const article = artdata[id.artid];
        if (!article) return null; // Safety check
        return (
            <div className="outerdiv">
                <div className="stdiv">
                    <div className="titler">
                        {(article.opinion?.toLowerCase() === "acadassoc")
                            ? `${article.position}, ${article.subject} - ${article.candidatename}`
                            : (article.opinion?.toLowerCase() === "csa") ? `${article.position} - ${article.candidatename}` : article.title}
                    </div>
                    {article.opinion?.toLowerCase() !== "csa" && article.opinion?.toLowerCase() !== "acadassoc" && (
                        <div className="credits">By {article.name}</div>
                    )}
                    <div className="timedate">
                        <div className="dater">{article.date}</div>
                        <div className="time">{Math.ceil((article.body ? article.body.split(/\s+/).length : 1) / 200)} min read</div>
                    </div>
                </div>
                <div className="nddiv">
                    {article.image && <img className="floater" src={article.image} />}
                    <div className="bodyerr">
                        {article.body}
                    </div>


                </div>
                <div className="rddiv">

                </div>
            </div>
        )
    }
    // return <>hello <button onClick={()=>{console.log(artdata[id.artid])}}>yello</button></>
}
